import React, {Component} from 'react';

import 'vendor/farbtastic/farbtastic.css';
import 'vendor/farbtastic/farbtastic.js';
import InputText from 'lib/struct/form/InputText';

import styles from './ColorPicker.less';

export default class ColorPicker extends Component {
	constructor() {
		super();
		this.state = {
			is_open: false
		};
	}

	componentDidMount() {
		const {value} = this.props;
		var $picker = $(this.picker);

		this.farbtastic = $.farbtastic($picker, (color) => {
			const {onChangeColor} = this.props;
			onChangeColor(color);
		});

		this.farbtastic.setColor('#'+value.substr(1));
	}

	render() {
		const {
			colorPicker: colorPickerClass,
			colorPicker__replacer: replacerClass,
			colorPicker__input: inputClass
		} = styles;
		const {is_open} = this.state;
		const {value, onChangeColor, ...props} = this.props;

		return (
			<div className={colorPickerClass}>
				<InputText
					{...props}
					className={inputClass}
					onChange={e => {
						this.farbtastic.setColor(e.target.value);
						onChangeColor(e.target.value);
					}}
					onFocus={e => this.setState({is_open: true})}
					onBlur={e => this.setState({is_open: false})}
					value={value}
					refNode={node => this.input = node}
				/>
				<span className={replacerClass + ' color-replacer'}
					onClick={e => this.input.focus()}
				>
					<i className='icon16 color' style={{background: '#' + value.substr(1)}} />
				</span>
				<div className='color-picker' ref={ref => this.picker = ref} style={{display: is_open ? 'block' : 'none'}} />
			</div>
		);
	}
}